import { PMSReservation, PMSServerReservation } from "../_models/PMSIntegration";

interface PMSServerReservationsPage {
    reservations: PMSServerReservation[];
    total_count: number;
}

export class PMSReservationMapper {
    static allServerToLocal(serverIntegrations: PMSServerReservation[]) {
        return serverIntegrations.map(this.serverToLocal);
    }

    static pageServerToLocal(serverPage: PMSServerReservationsPage) {
        return {
            items: this.allServerToLocal(serverPage?.reservations ?? []),
            total_count: serverPage?.total_count ?? 0,
        };
    }

    static serverToLocal({
        status,
        reservation_end,
        reservation_id,
        reservation_start,
        early_checkout_at,
        early_checkin_at,
        early_checkin_offered_at,
        early_checkin_confirmed_at,
        early_checkin_rejected_at,
        invitation_uid,
        keypad_code,
        email,
        guest_name,
        uid,
        created_on,
        modified_on,
        integration,
        url,
        location_name,
        location_uid,
        is_manual,
    }: PMSServerReservation): PMSReservation {
        return {
            integration,
            status,
            uid,
            email,
            guestName: guest_name,
            reservationEnd: reservation_end,
            reservationStart: reservation_start,
            earlyCheckoutAt: early_checkout_at,
            earlyCheckinAt: early_checkin_at ?? null,
            earlyCheckinOfferedAt: early_checkin_offered_at ?? null,
            earlyCheckinConfirmedAt: early_checkin_confirmed_at ?? null,
            earlyCheckinRejectedAt: early_checkin_rejected_at ?? null,
            invitationUid: invitation_uid ?? null,
            keypadCode: keypad_code ?? null,
            reservationId: reservation_id,
            createdOn: created_on,
            modifiedOn: modified_on,
            url: url,
            locationName: location_name ?? null,
            locationUid: location_uid ?? null,
            isManual: !!is_manual,
        };
    }

}